export default __webpack_public_path__ + "static/media/privacy-policy-capnobook.1b394823.pdf";